'use client';

import { cn } from '@repo/ui';
import { Loader2, Pause, Volume2 } from 'lucide-react';
import type { JSX } from 'react';

interface IAudioIconProps {
  isLoading: boolean;
  isPlaying: boolean;
  className?: string;
  iconClassName?: string;
}

export function AudioIcon({
  isLoading,
  isPlaying,
  className,
  iconClassName = 'size-4',
}: IAudioIconProps): JSX.Element {
  const Icon = isLoading ? Loader2 : isPlaying ? Pause : Volume2;
  return (
    <span aria-hidden className={cn('inline-flex text-muted-foreground', className)}>
      <Icon className={cn(iconClassName, isLoading && 'animate-spin')} />
    </span>
  );
}
